import React, { useEffect, useState } from "react";
import ConfigProps from "../../constants/configProps";
import ConfigPropService from "../../utilities/configPropService";

export const wbmLiveChatBootstrapId = "wbm-live-chat-bootstrap";

function LiveChat() {
  const [chatId, setChatId] = useState("");
  const [enabled, setEnabled] = useState(false);
  const [cafeXId, setCafeXId] = useState("");

  useEffect(() => {
    const configPropSub = ConfigPropService.get([
      ConfigProps.EnableCafeXWebChat,
      ConfigProps.CafeXID,
      ConfigProps.HeaderEmbeddedWebChatID,
    ]).subscribe((configProps) => {
      setCafeXId(configProps[ConfigProps.CafeXID]);
      setEnabled(
        ConfigPropService.isYesOrTrue(
          configProps[ConfigProps.EnableCafeXWebChat]
        )
      );
      setChatId(configProps[ConfigProps.HeaderEmbeddedWebChatID]);
    });

    return () => {
      configPropSub.unsubscribe();
    };
  }, []);

  return (
    <div id={wbmLiveChatBootstrapId} className="d-none">
      {enabled && chatId && cafeXId && <div id={chatId}></div>}
    </div>
  );
}

export default LiveChat;
